import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import FaqSection from "../sections/FaqSection";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Faqs() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <>
            <section className="faqs-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="font-bold text-white text-[40px] capitalize">{t("Faqs")}</div>
                        <div className="flex items-center justify-center gap-[4px]">
                            <Link className="text-white capitalize" to={"/"}>{t("Home")}</Link>
                            <span className="text-white capitalize">-</span>
                            <div className="text-white capitalize">{t("Faqs")}</div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col justify-between">
                    <div className="flex flex-col gap-[7px]">
                        <div className="btmAni20002 font-bold text-[30px]">{t("Frequently Asked Questions")}</div>
                        <p className="btmAni3000 leading-[1.1]">
                            {t("fText")}
                        </p>
                    </div>
                    <FaqSection />
                    <div className="rounded-[8px] bg-[#132A40] py-[35px] px-[20px] flex items-center flex-col gap-[15px] justify-center">
                        <div className="js-scroll fade-top w-100 w-[75%] text-center capitalize text-white text-[25px]">{t("If you don’t find the information you need, feel free to")} 
                            <span className="js-scroll fade-top text-[#B39359] capitalize">{t(" contact us")}</span> {t("we're happy to help! ")}
                        </div>
                        <Link to={"/contact"} className="js-scroll fade-btm bg-[#B39359] text-white px-[35px] py-[8px] rounded font-bold capitalize">{t("Contact us now")}</Link>
                    </div>
                </div>
            </section>
        </>
    );
}